/* eslint @typescript-eslint/no-redundant-type-constituents: 0 */
import { IntlMessageFormat } from 'intl-messageformat';

const _list_modal_all_fr = new IntlMessageFormat([{ type: 0, value: 'Toutes' }], 'fr');

export function list_modal_all(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _list_modal_all_fr.format(args) as unknown as string;
    }

    return _list_modal_all_fr.format(args) as unknown as string;
}

const _like_fr = new IntlMessageFormat([{ type: 0, value: "J'aime" }], 'fr');

export function like(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _like_fr.format(args) as unknown as string;
    }

    return _like_fr.format(args) as unknown as string;
}

const _love_fr = new IntlMessageFormat([{ type: 0, value: "J'adore" }], 'fr');

export function love(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _love_fr.format(args) as unknown as string;
    }

    return _love_fr.format(args) as unknown as string;
}

const _haha_fr = new IntlMessageFormat([{ type: 0, value: 'Haha' }], 'fr');

export function haha(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _haha_fr.format(args) as unknown as string;
    }

    return _haha_fr.format(args) as unknown as string;
}

const _wow_fr = new IntlMessageFormat([{ type: 0, value: 'Wouah' }], 'fr');

export function wow(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _wow_fr.format(args) as unknown as string;
    }

    return _wow_fr.format(args) as unknown as string;
}

const _sad_fr = new IntlMessageFormat([{ type: 0, value: 'Triste' }], 'fr');

export function sad(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _sad_fr.format(args) as unknown as string;
    }

    return _sad_fr.format(args) as unknown as string;
}

const _angry_fr = new IntlMessageFormat([{ type: 0, value: 'Grrr' }], 'fr');

export function angry(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _angry_fr.format(args) as unknown as string;
    }

    return _angry_fr.format(args) as unknown as string;
}

const _select_reaction_fr = new IntlMessageFormat(
    [
        {
            type: 5,
            value: 'reaction',
            options: {
                like: { value: [{ type: 0, value: "J'aime" }] },
                love: { value: [{ type: 0, value: "J'adore" }] },
                haha: { value: [{ type: 0, value: 'Haha' }] },
                wow: { value: [{ type: 0, value: 'Wouah' }] },
                sad: { value: [{ type: 0, value: 'Triste' }] },
                angry: { value: [{ type: 0, value: 'Grrr' }] },
                __not_other: { value: [] },
                other: { value: [] },
            },
        },
    ],
    'fr',
);

export function select_reaction(
    args: { reaction: 'angry' | 'haha' | 'like' | 'love' | 'sad' | 'wow' },
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _select_reaction_fr.format(args) as unknown as string;
    }

    return _select_reaction_fr.format(args) as unknown as string;
}
